<template>
  <v-dialog v-model="dialog" max-width="1400px" persistent scrollable>
    <v-card>
      <v-card-title class="d-flex align-center">
        <span class="text-h5">{{ isNewRecord ? '新增CRM' : '編輯CRM' }}</span>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4" style="max-height: 70vh; height: 70vh">
        <CRMDetailsForm
          v-if="dialog"
          ref="form"
          :key="id"
          :id="id"
          :initial-data="initialData"
          @saved="handleSaved"
          @cancel="close"
          @deleted="handleDeleted"
          @duplicate="handleDuplicate"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CRMDetailsForm from './CRMDetailsForm';

export default {
  name: 'CRMDetailsDialog',
  components: {
    CRMDetailsForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'new',
    },
    initialData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isNewRecord() {
      return !this.id || this.id === 'new';
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    handleSaved() {
      this.$emit('saved');
      this.close();
    },
    handleDeleted() {
      this.$emit('deleted');
      this.close();
    },
    handleDuplicate(data) {
      this.$emit('duplicate', data);
      this.close();
    },
  },
};
</script>
